import { DateTime } from 'luxon'
import React from 'react'
import * as Avatar from '../Avatar'
import { truncate } from 'utils'
import * as Content from '../Content'
import { Title } from './Title'
import { Subtitle } from './Subtitle'
import { Body } from './Body'
import { View, CardViewProps } from './View'

export interface IMessage {
  participantCount?: number | null
  avatarUrl?: string
  color?: string
  eventName?: string | null
  eventIconUrl?: string | null
  from: string
  content: string
  updatedAt: string
  id: string
}

export interface IMessageCardProps extends CardViewProps {
  message: IMessage
}

export const Message: React.FC<IMessageCardProps> = ({ message, ...box }) => {
  const participantCount = parseInt(`${message.participantCount}`)
  return (
    <View {...box}>
      <div className="mr-2 flex-shrink-0">
        <Avatar.Simple
          name={message.from}
          maxInitials={2}
          imageUrl={message.avatarUrl}
          color={message.color}
          className="mb-0"
        />
      </div>
      <article className="flex flex-grow items-start min-w-0">
        <div className="flex flex-col flex-grow min-w-0 pr-2">
          {message.eventName ? (
            <section className="flex items-center min-w-0">
              <Avatar.Simple
                name={message.eventName}
                imageUrl={message.eventIconUrl as string}
                maxInitials={1}
                size={18}
                color={message.color}
                className="mr-2 mb-0"
              />
              <Subtitle>{truncate(message.eventName ?? '', 14)}</Subtitle>
            </section>
          ) : null}
          <section className="flex items-start min-w-0">
            <Title className="min-w-0 flex-1">{message.from}</Title>{' '}
            {participantCount > 2 ? (
              <p className="pl-2">
                <Content.Bubble>+{participantCount - 1}</Content.Bubble>
              </p>
            ) : null}
          </section>
          <Body>{truncate(message.content, 50)}</Body>
        </div>
        <div className="flex flex-shrink-0 flex-grow-0">
          <Body>
            {DateTime.fromISO(message.updatedAt).toFormat('M/dd/yyyy')}
          </Body>
        </div>
      </article>
    </View>
  )
}

Message.displayName = 'Card.Message'
